/*globals jQuery, moment, Zoomer, Mgp*/

(function () {
  'use strict';

  var globalizedValue;

  $.extend($.validator.messages, {
    required: 'This field is required.',
    remote: 'Please fix this field.',
    email: 'Please enter a valid email address.',
    url: 'Please enter a valid URL.',
    date: 'Please enter a valid date.',
    dateISO: 'Please enter a valid date (ISO).',
    number: 'Please enter a valid number.',
    digits: 'Please enter only digits.',
    creditcard: 'Please enter a valid credit card number.',
    equalTo: 'Please enter the same value again.',
    accept: 'Please enter a value with a valid extension.',
    maxlength: $.validator.format('Please enter no more than {0} characters.'),
    minlength: $.validator.format('Please enter at least {0} characters.'),
    rangelength: $.validator.format('Please enter a value between {0} and {1} characters long.'),
    range: $.validator.format('Please enter a value between {0} and {1}.'),
    max: $.validator.format('Please enter a value less than or equal to {0}.'),
    min: $.validator.format('Please enter a value greater than or equal to {0}.')
  });

  //override jquery validate plugin defaults
  $.validator.setDefaults({
    highlight: function (element) {
      var $group = $(element).closest('.form-group');

      if ($group.hasClass('multi-validation-group')) {
        $(element).removeClass('input-valid');
        $(element).parent('.input-group').removeClass('input-valid');
      }

      $group.addClass('has-error');
    },
    unhighlight: function (element) {
      var $group = $(element).closest('.form-group');
      var removeClass = true;

      if ($group.hasClass('multi-validation-group')) {
        removeClass = $group.hasClass('.has-error:not(:hidden)').length === 0 ||
                      ($group.find('input,select,textarea').filter(':visible').length ===
                      $group.find('input.input-valid, select.input-valid,textarea.input-valid').length);
        
        $(element).addClass('input-valid');
        $(element).parent('.input-group').addClass('input-valid');
      }
      if (removeClass) {
        $group.removeClass('has-error');
      }
    },
    errorElement: 'span',
    errorClass: 'help-error-info',
    errorPlacement: function (error, element) {
      if (element.parent('.input-group').length) {
        error.insertAfter(element.parent());
      }
      else if (element.parents('.yes-no-toggle').length) {  //used for yes-no-toggle
        error.insertAfter(element.parents('.bootstrap-wrapper'));
      }
      else if (element.parents('.radio-inline').length || element.parents('.radio').length || element.parents('.checkbox').length || element.parents('.checkbox-inline').length) {  //used for radio/checkbox inputs
        var $formGroup = element.parents('.form-group.has-error:first');
        var $radioContainer = $formGroup.find('.radio-inline, .radio, .checkbox, .checkbox-inline').last();

        error.insertAfter($radioContainer);
      }
      else {
        error.insertAfter(element);
      }

      //for web accessibility - aria-atomic is necessary to make Voiceover on iOS read the error messages after more than one invalid submission.
      error.find('.help-error-info').attr('aria-atomic', 'true'); 
    },
    wrapper: 'div',  //Added for yes-no-toggle to send wrap msg to new line - may need to do another way
    ignore: ':hidden:not(.validate-hidden), .disable, .disabled',
    //http://stackoverflow.com/questions/1827483/jquery-validate-plugin-how-to-trim-values-before-form-validation/6472021#comment22281032_6472021
    //if the form is submitted while the the field is invalid, entering legitimate space (e.g. the ones between names and surnames) 
    //afterwards into it gets hard esp. for slower typers: jsfiddle.net/halilim/ftwqg Set onkeyup: false to prevent this.
    onkeyup: false,
    success: 'valid',
    //Open toggle collapsed sections if they are closed but have validation errors - Retirement Goal uses this
    invalidHandler: function (form, validator) {
      if (typeof (Zoomer) !== 'undefined') {
        Zoomer.NavigateLoadingStop();
      }
      else {
        if (typeof (Mgp) !== 'undefined') {
          Mgp.Navigate.LoadingStop();
        }
      }

      validator.showErrors();

      if (validator.numberOfInvalids() > 0) {
        var $collapsedSection = $('.has-error').closest('.collapse'),
            collapsedSectionId = $collapsedSection.attr('id');

        if ($collapsedSection.length > 0) {
          $('#' + collapsedSectionId).collapse('show');
        }

        $('html, body').animate({
          scrollTop: ($(validator.errorList[0].element).offset().top - 100)
        }, 250);
      }
    }
  });

  //http://stackoverflow.com/questions/1827483/jquery-validate-plugin-how-to-trim-values-before-form-validation/6472021#comment22281032_6472021
  $.each($.validator.methods, function (key, value) {
    $.validator.methods[key] = function () {
      if (arguments.length > 0) {
        arguments[0] = $.trim(arguments[0]);
      }
      return value.apply(this, arguments);
    };
  });

  //http://rebuildall.umbraworks.net/rebuildall/2011/03/02/jQuery_validate_and_the_comma_decimal_separator
  $.validator.methods.number = function (value, element) {
    return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:[\s\.,]\d{3})+)(?:[\.,]\d+)?$/.test(value);
  };

  $.validator.methods.range = function (value, element, param) {
    globalizedValue = value.replace(/\,/g, '');
    return this.optional(element) || (globalizedValue >= param[0] && globalizedValue <= param[1]);
  };

  $.validator.methods.min = function (value, element, param) {
    var fieldOk;

    globalizedValue = window.parseFloat(value.replace(/\,/g, ''));

    fieldOk = this.optional(element) || globalizedValue >= param;

    //If we need to reset to min value when invalid
    //if (!fieldOk) {
    //  $(element).val($(element).attr('min'));
    //}

    return fieldOk;
  };

  $.validator.methods.max = function (value, element, param) {
    var fieldOk,
        max;

    globalizedValue = window.parseFloat(value.replace(/\,/g, ''));

    fieldOk = this.optional(element) || globalizedValue <= param;

    //If we need to reset to max value when invalid
    //if (!fieldOk) {
    //  $(element).val($(element).attr('max'));
    //}

    //Add formatting to numbers for readability
    if ($(element).data('is-date') === true) {
      max = $(element).attr('max');
    } else {
      max = formatNumberWithCommas($(element).attr('max'));
    }

    $.validator.messages.max = 'Please enter a value less than or equal to ' + max + '.';

    return fieldOk;
  };

  //Override default maxlength validator - don't validate maxlength (Case 7473) if it is a 
  //MoneyEditorFor, RateEditorFor, AgeYearsEditor, AgeMonthsEditor MVC input, 
  //use min and max attributes on these inputs
  $.validator.methods.maxlength = function (value, element, param) {
    var $elem = $(element);

    if ($elem.hasClass('format-amount') ||
        $elem.hasClass('format-rate') ||
        $elem.hasClass('format-age-years') ||
        $elem.hasClass('format-age-months')) {
      return true;
    }
    else {
      var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			
      return this.optional(element) || length <= param;
    }		
  },

  //Date Validation
  //http://www.regular-expressions.info/dates.html
  $.validator.addMethod(
     'dateFormatMMDDYYYY',
     function (value, element) {
       var datePattern = /^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20|21)\d\d$/,
           isdateValid = true,
           dateArray,
           day,
           month,
           year;
           
       if (datePattern.test(value)) {
         dateArray = value.split('/');
         month = dateArray[0];
         day = dateArray[1];
         year = dateArray[2];

         if (day === '31' && 
            (month === '4' || month === '6' || month === '9' ||
                 month === '11' || month === '04' || month === '06' ||
                 month === '09')) {
           isdateValid = false; // only 1,3,5,7,8,10,12 has 31 days
         } else if (month === '2' || month === '02') {
           //leap year
           if(year % 4 === 0){
             if(day === '30' || day === '31'){
               isdateValid = false;
             }
           } else {
             if(day === '29' || day === '30' || day === '31'){
               isdateValid = false;
             }
           }
         }
       }
       else {
         isdateValid = false;
       }
       return this.optional(element) || isdateValid;
     },
     'Please enter a valid date in the format mm/dd/yyyy.');

  $.validator.addMethod(
    'valMMDDYYYYCurrentOrFuture',
    function (value, element) {
      var maxYearsInFuture;

      if (typeof $(element).data('max-years') !== 'undefined') {
        maxYearsInFuture = $(element).data('max-years');
      }
      else {
        maxYearsInFuture = window.INVESTORMAXLIFEEXPECTANCY;
        $(element).data('max-years', window.INVESTORMAXLIFEEXPECTANCY);
      }

      return this.optional(element) ||
        moment().startOf('day').diff(new Date(value), 'days', true) <= 0 &&
        moment().startOf('day').diff(new Date(value), 'years', true) >= -maxYearsInFuture;

    }, function (params, element) {
      return 'Please enter the current date or a date in the future. This can not be more than ' + $(element).data('max-years') + ' years in the future.';
  });

  $.validator.addMethod(
    'valMMDDYYYYCurrentOrPast',
    function (value, element) {
      var maxYearsInPast;

      if (typeof $(element).data('max-years') !== 'undefined') {
        maxYearsInPast = $(element).data('max-years');
      }
      else {
        maxYearsInPast = window.INVESTORMAXAGE;
        $(element).data('max-years', window.INVESTORMAXAGE);
      }

      return this.optional(element) ||
        moment().startOf('day').diff(new Date(value), 'days', true) >= 0 &&
        moment().startOf('day').diff(new Date(value), 'years', true) <= maxYearsInPast;
    }, function (params, element) {
      return 'Please enter a current or past date. This must be less than ' + $(element).data('max-years') + ' years in the past.';
    });

  $.validator.addMethod(
     'valMMDDYYYYPast',
     function (value, element) {
       return this.optional(element) || moment().startOf('day').diff(new Date(value), 'days', true) > 0;
     },
     'Please enter a date in the past.');

  $.validator.addMethod(
      'dateFormatMMYYYY',
      function (value, element) {
        return this.optional(element) || /^(0[1-9]|1[012])[/](19|20|21)\d\d$/.test(value);
      },
      'Please enter a valid date in the format mm/yyyy.');

  $.validator.addMethod(
    'valMMYYYYCurrentOrPast',
    function (value, element) {
      var currentDate = new Date(),
          currentMonth = parseInt(currentDate.getMonth() + 1),
          currentYear = parseInt(currentDate.getFullYear()),
          dateArray = value.split('/'),
          month = parseInt(dateArray[0]),
          year = parseInt(dateArray[1]),
          yearsInPast = parseInt(currentYear) - parseInt(year),
          maxYearsInPast;

      if (typeof $(element).data('max-years') !== 'undefined') {
        maxYearsInPast = $(element).data('max-years');
      }
      else {
        maxYearsInPast = window.INVESTORMAXAGE;
        $(element).data('max-years', window.INVESTORMAXAGE);
      }

      return this.optional(element) ||
        (year < currentYear ||
        (year === currentYear && month <= currentMonth)) &&
        (yearsInPast < maxYearsInPast ||
        yearsInPast === maxYearsInPast && month > currentMonth);
    }, function (params, element) {
      return 'Please enter a current or past date. This must be less than ' + $(element).data('max-years') + ' years in the past.';
    });

  $.validator.addMethod(
    'valMMYYYYCurrentOrFuture',
    function (value, element) {
      var currentDate = new Date(),
          currentMonth = parseInt(currentDate.getMonth() + 1),
          currentYear = parseInt(currentDate.getFullYear()),
          dateArray = value.split('/'),
          month = parseInt(dateArray[0]),
          year = parseInt(dateArray[1]),
          yearsInFuture = parseInt(year) - parseInt(currentYear),
          maxYearsInFuture;

      if (typeof $(element).data('max-years') !== 'undefined') {
        maxYearsInFuture = $(element).data('max-years');
      }
      else {
        maxYearsInFuture = window.INVESTORMAXLIFEEXPECTANCY;
        $(element).data('max-years', window.INVESTORMAXLIFEEXPECTANCY);
      }

      return this.optional(element) ||
        (year > currentYear ||
        (year === currentYear && month >= currentMonth)) &&
        (yearsInFuture < maxYearsInFuture ||
        yearsInFuture === maxYearsInFuture && month < currentMonth);
    }, function (params, element) {
      return 'Please enter the current date or a date in the future. This can not be more than ' + $(element).data('max-years') + ' years in the future.';
  });

  $.validator.addMethod(
     'dateFormatYYYY',
     function (value, element) {
       return this.optional(element) || /^(19|20|21)\d\d$/.test(value);
     },
     'Please enter a valid date in the format yyyy.');

  $.validator.addMethod(
     'valYYYYCurrentOrFuture',
     function (value, element) {
       var currentDate = new Date(),
         currentYear = parseInt(currentDate.getFullYear()),
         year = value,
         yearsInFuture = parseInt(year) - parseInt(currentYear),
         maxYearsInFuture;

       if (typeof $(element).data('max-years') !== 'undefined') {
         maxYearsInFuture = $(element).data('max-years');
       }
       else {
         maxYearsInFuture = window.INVESTORMAXLIFEEXPECTANCY;
         $(element).data('max-years', window.INVESTORMAXLIFEEXPECTANCY);
       }
       return this.optional(element) || (year >= currentYear && yearsInFuture <= maxYearsInFuture);
     }, function (params, element) {
       return 'Please enter a current or future year. This can not be more than ' + $(element).data('max-years') + ' years in the future.';
  });

  $.validator.addMethod(
     'valYYYYCurrentOrPast',
     function (value, element) {
      var currentDate = new Date(),
        currentYear = parseInt(currentDate.getFullYear()),
        year = value,
        yearsInPast = parseInt(currentYear) - parseInt(year),
        maxYearsInPast;

      if (typeof $(element).data('max-years') !== 'undefined') {
        maxYearsInPast = $(element).data('max-years');
      }
      else {
        maxYearsInPast = window.INVESTORMAXLIFEEXPECTANCY;
        $(element).data('max-years', window.INVESTORMAXLIFEEXPECTANCY);
      }
       return this.optional(element) || (year <= currentYear && yearsInPast <= maxYearsInPast);
    }, function (params, element) {
      return 'Please enter a current or past year. This can not be more than ' + $(element).data('max-years') + ' years in the past.';
    });

  $.validator.addMethod(
     'valYYYYPast',
     function (value, element) {
      var currentDate = new Date(),
        currentYear = parseInt(currentDate.getFullYear()),
        year = value,
        yearsInPast = parseInt(currentYear) - parseInt(year),
        maxYearsInPast;

      if (typeof $(element).data('max-years') !== 'undefined') {
        maxYearsInPast = $(element).data('max-years');
      }
      else {
        maxYearsInPast = window.INVESTORMAXLIFEEXPECTANCY;
        $(element).data('max-years', window.INVESTORMAXLIFEEXPECTANCY);
      }
      return this.optional(element) || (year < currentYear && yearsInPast <= maxYearsInPast);
    }, function (params, element) {
      return 'Please enter a past year. This can not be more than ' + $(element).data('max-years') + ' years in the past.';
    });

  $.validator.addMethod(
     'valYYYYFuture',
     function (value, element) {
       var currentDate = new Date(),
         currentYear = parseInt(currentDate.getFullYear()),
         year = value,
         yearsInFuture = parseInt(year) - parseInt(currentYear),
         maxYearsInFuture;

       if (typeof $(element).data('max-years') !== 'undefined') {
         maxYearsInFuture = $(element).data('max-years');
       }
       else {
         maxYearsInFuture = window.INVESTORMAXLIFEEXPECTANCY;
         $(element).data('max-years', window.INVESTORMAXLIFEEXPECTANCY);
       }
       return this.optional(element) || (year > currentYear && yearsInFuture <= maxYearsInFuture);
    }, function (params, element) {
       return 'Please enter a future year. This can not be more than ' + $(element).data('max-years') + ' years in the future.';
  });

  $.validator.addMethod(
    'valTimeOfDayAmPm',
    function (value, element) {
      return this.optional(element) || /^(0?[1-9]|1[012])(:[0-5]\d)[APap][mM]$/.test(value);
    },
    'Please enter a valid time.');

  //Character Validation
  //$.validator.addMethod(
  //    'excludeCharacters',
  //    function (value, element) {
  //      var trimmedValue = $.trim(value);

  //      return this.optional(element) || /^[^,&><':;"\?%~\\=]+$/.test(trimmedValue);
  //    },
  //    'This field cannot use one of the non-alphanumeric characters entered.');

  //- Don't allow " or a javascript error may occur with delete and edit links
  //- Don't allow < with text after it or a "A potentially dangerous Request.Form value was 
  //  detected from the client" error may occur in processing inputs
  //- Don't allow \ as the last character in a description or a javascript error may occur
  //- Don't allow the just non-alphanumeric characters in fields - (e.g. "?") - in legacy 
  //  stuff "String too short error" - Case 8085
  $.validator.addMethod(
      'excludeCharactersDescField',
      function (value, element) {
        var trimmedValue = $.trim(value);

        return this.optional(element) ||
          (trimmedValue.search(/"/) === -1 &&
            trimmedValue.search(/<.+/) === -1 &&
            trimmedValue.search(/[\\]$/) === -1 &&
            (trimmedValue.match(/[0-9a-zA-Z]/g) && trimmedValue.length > 0) &&
            !containsDisallowedEmoji(trimmedValue));
      },
      'This field cannot use one of the non-alphanumeric or Unicode characters entered.');

  $.validator.addMethod(
    'excludeJavaScript',
    function (value, element) {
      var trimmedValue = $.trim(value).toLowerCase();

      return this.optional(element) ||
        (!trimmedValue.match(/<script[\s>]/i) &&
        !trimmedValue.match(/<\/script>/i) && 
        !trimmedValue.match(/javascript:/i) &&
        !trimmedValue.match(/on\w+\s*=/i) &&
        !trimmedValue.match(/data:text\/html/i) &&
        !trimmedValue.match(/<iframe/i) &&
        !trimmedValue.match(/<object/i) &&
        !trimmedValue.match(/<embed/i));
    },
    'This field cannot use JavaScript.');

  //UserName Validation
  $.validator.addMethod(
      'userId',
       function (value, element) {
         return this.optional(element) ||
           (value.search(/^[A-Za-z0-9@._-][A-Za-z0-9@._-][A-Za-z0-9@._-][A-Za-z0-9@._-][A-Za-z0-9@._-]+$/) !== -1);
       },
       'Please enter a valid User ID. Must be at least 5 characters long and may contain alphanumeric and the . _ - @ characters. It may not contain whitespaces.');

  ////Email Validation
  $.validator.addMethod(
      'email',
       function (value, element) {
         return this.optional(element) || window.EMAIL_VALIDATION_REGEX.test(value);
       },
       'Please enter a valid email.');

  ////Phone Validation
  $.validator.addMethod('phoneNumber', function (phone_number, element) {
    var phone_number = phone_number.replace(/\s+/g, '');

    return this.optional(element) || phone_number.length > 9 &&
    phone_number.match(/^\d{3}-\d{3}-\d{4}([X|x][0-9]+)*$/);
  }, 'Please enter a valid phone number in the format 555-555-5555x123. The extension is optional.');

  ////Phone Validation
  $.validator.addMethod('phoneNumberNoExt', function (phone_number, element) {
    var phone_number = phone_number.replace(/\s+/g, '');

    return this.optional(element) || phone_number.length > 9 &&
    phone_number.match(/^\d{3}-\d{3}-\d{4}$/);
  }, 'Please enter a valid phone number in the format 555-555-5555.');

 $.validator.addMethod('zipCode', function (value, element) {
    return this.optional(element) || /\d{5}-\d{4}$|^\d{5}$/.test(value)
  }, 'The specified US ZIP Code is invalid.');

  $.validator.addMethod("greaterThanZero", function (value, element) {
    return this.optional(element) || (parseFloat(value) > 0);
  }, 'Please enter a value greater than 0.');

  //Added this number formatter so it can be used in Blocks without using formatAmount in jsLibFormat.js and it's dependent js libraries
  function formatNumberWithCommas(num) {
    var parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  //Jira MGFUTURE-13084 - Block emoji characters using Unicode ranges
  //1F600-1F64F: Emoticons (smileys, gestures)
  //1F300-1F5FF: Misc Symbols and Pictographs (weather, animals, food)
  //1F680-1F6FF: Transport and Map Symbols
  //1F700-1F77F: Alchemical Symbols
  //1F780-1F7FF: Geometric Shapes Extended
  //1F800-1F8FF: Supplemental Arrows-C
  //1F900-1F9FF: Supplemental Symbols and Pictographs
  //1FA00-1FA6F: Chess Symbols
  //1FA70-1FAFF: Symbols and Pictographs Extended-A
  //2600-26FF: Misc symbols (sun, moon, stars, zodiac)
  //2700-27BF: Dingbats (arrows, shapes)
  function containsDisallowedEmoji(value) {
    return /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u.test(value);
  }
})(jQuery);